{
  "acsSlow": {
    "body": "Nous vous mettons en contact avec l’opérateur de votre méthode de paiement pour autoriser la transaction.",
    "title": "En attente de la réponse de votre banque…"
  },
  "app": {
    "title": "Payer un avis - pagoPA"
  },
  "ariaLabels": {
    "appLanguage": "Sélectionner la langue",
    "close": "Fermer",
    "editCard": "Modifier les données de la carte",
    "editDonation": "Modifier l’organisation destinataire du don",
    "editPsp": "Modifier PSP",
    "informationDialog": "Informations sur les frais de commission",
    "informationLink": "Pour en savoir plus sur la campagne de",
    "languageMenu": "Langue sélectionnée",
    "loading": "Chargement en cours",
    "applySorting": "Appliquer l’ordre sélectionné",
    "sortingDefault": "Ordre par défaut",
    "sortingName": "Ordre par nom",
    "sortingAmount": "Ordre par montant"
  },
  "cancelledPage": {
    "body": "L'opération a été annulée",
    "button": "Fermer"
  },
  "authCallbackPage": {
    "title": "L’accès n’a pas été possible",
    "body": "Un problème est survenu lors de la connexion. Veuillez réessayer dans quelques minutes.",
    "buttons": {
      "retry": "Réessayer",
      "continueWithoutLogin": "Continuer sans connexion"
    }
  },
  "authExpiredPage": {
    "title": "Votre session a expiré",
    "body": "Connectez-vous pour reprendre la session, ou continuez sans vous connecter ",
    "buttons": {
      "login": "Connectez-vous",
      "continueWithoutLogin": "Continuer sans connexion"
    }
  },
  "cartDetail": {
    "amount": "Montant",
    "companyName": "Organisme créancier",
    "description": "Objet du paiement",
    "fiscalCode": "Code fiscal organisme créancier",
    "iuv": "Code IUV",
    "noticeNumber": "Code avis"
  },
  "clipboard": {
    "copied": "Copié",
    "copy": "Copier",
    "edit": "Modifier"
  },
  "DOMAIN_UNKNOWN": {
    "title": "La réponse de l’organisme créancier est perturbée",
    "buttons": {
      "close": "Fermer",
      "help": "Contacter l’assistance"
    }
  },
  "DONATIONLIST_ERROR": "Nous n’avons pas réussi à télécharger la liste des organisations.",
  "donationPage": {
    "click": "appuyer",
    "code": "et scanner le code :",
    "description": "Vous avez jusqu’au 23 décembre. Vous pouvez faire un don avec votre carte sans payer des frais. Le montant du don est versé directement sur le compte de l’organisation de votre choix.",
    "dismissCTA": "Voir les organisations",
    "dismissDescription": "Si vous le voulez, vous pouvez faire un don à une des organisations humanitaires qui ont adhéré à cette initiative.",
    "dismissTitle": "Le service a été désactivé",
    "entity": "À qui voulez-vous faire un don ?",
    "ioDescription": "Faites un don avec l’appli IO et recevez un e-mail avec toutes les informations nécessaires pour bénéficier des exonérations fiscales.",
    "modalBody2": "Vous pouvez faire un don sans payer des frais avec votre carte.",
    "modalTitle": "Continuer sur l’appli IO",
    "openSection": "Ouvrir la section",
    "payNotice": "Payer un avis",
    "portfolio": "Portefeuille",
    "submitCard": "Faire un don avec une carte",
    "submitIO": "Faire un don avec IO",
    "title": "Faire un don pour la crise en Ukraine",
    "volunteer": "Combien voulez-vous donner ?"
  },
  "errorButton": {
    "close": "Fermer",
    "help": "Contacter l’assistance",
    "retry": "Réessayer"
  },
  "ErrorCodeDescription": "Code erreur pour l’assistance",
  "GENERIC_ERROR": {
    "body": "Réessayez ou contactez l'assistance.",
    "title": "Une erreur inattendue s’est produite"
  },
  "general": {
    "and": "et"
  },
  "indexPage": {
    "description": "Vous pouvez payer par carte, compte ou appli de paiement. Vous recevrez le résultat du paiement par e-mail.",
    "title": "Payer un avis"
  },
  "iframeCardPage": {
    "helpLink": "Où se trouve le CVV?",
    "modalTitle": "Où se trouve le CVV?",
    "modalBodyText": "Le code CVV (ou CVC) a 3 chiffres et vous le trouvez au dos de votre carte.<br>Sur les cartes American Express, le code (CID) a 4 chiffres et il est situé à l’avant.",
    "buttonClose": "Fermer"
  },
  "inputCardPage": {
    "formErrors": {
      "cid": "Saisir 4 chiffres",
      "cvv": "Saisir 3 chiffres",
      "expirationDate": "Saisir mm/aa",
      "name": "Saisir les informations inscrites sur la carte",
      "number": "Saisir un numéro valide",
      "required": "Champ obligatoire"
    },
    "formFields": {
      "cid": "CID (4 chiffres)",
      "cvv": "CVV",
      "expirationDate": "Date d’expiration",
      "name": "Titulaire carte",
      "number": "Numéro carte",
      "required": "Champ obligatoire"
    },
    "helpLink": "Où se trouve le code de sécurité ?",
    "modal": {
      "description": "Le code à trois chiffres CVV ou CVS se trouve au dos de votre carte.",
      "descriptionAE": "Sur les cartes American Express, le code (CID) à quatre chiffres est placé devant.",
      "title": "Code de sécurité"
    },
    "title": "Saisir les informations de la carte"
  },
  "INVALID_CARD": {
    "body": "Essayez de saisir une carte valide ou contactez-nous pour obtenir une assistance.",
    "title": "Désolés, cette carte n’est pas valide"
  },
  "INVALID_DECODE": {
    "body": "Réessayez ou contactez-nous pour obtenir une assistance.",
    "title": "Une erreur s’est produite pendant la lecture des données"
  },
  "INVALID_QRCODE": {
    "body": "Si le problème persiste, réessayez et tentez de saisir les données manuellement.",
    "title": "Le code scanné n’est pas un avis pagoPA"
  },
  "koPage": {
    "body": "Aucun débit n’a été effectué.",
    "button": "Fermer",
    "helpButton": "Pouvons-nous vous aider ?",
    "learnMoreButton": "En savoir plus",
    "title": "Une erreur inattendue s’est produite"
  },
  "mainPage": {
    "footer": {
      "accessibility": "Accessibilité",
      "help": "Aide",
      "privacy": "Confidentialité",
      "terms": "Conditions",
      "platformStatus": "Statut de la plateforme",
      "pagoPA": "Visiter le site pagoPA"
    },
    "header": {
      "login": "Connectez-vous",
      "logout": "Se déconnecter",
      "detail": {
        "detailButton": "Ouvrir le résumé du paiement",
        "detailFC": "Code fiscal organisme créancier",
        "detailIUV": "Code IUV",
        "detailAmount": "Total partiel",
        "detailReceiver": "Organisme créancier",
        "detailSubject": "Objet du paiement",
        "detailTitle": "Détail avis"
      },
      "disclaimer": "Le montant est mis à jour automatiquement : vous payez toujours à temps, sans pénalités ni intérêts de retard."
    },
    "main": {
      "skipToContent": "Aller au contenu principal"
    }
  },
  "NOTLISTED": {
    "body": "Réessayez ou contactez-nous pour obtenir une assistance.",
    "title": "Une erreur inattendue s’est produite"
  },
  "PAYMENT_CANCELED": {
    "body": "Contactez l’organisme pour obtenir des informations supplémentaires.",
    "title": "L’organisme créancier a annulé cet avis."
  },
  "PAYMENT_DATA_ERROR": {
    "title": "Les données de l’avis ne sont pas correctes"
  },
  "PAYMENT_DUPLICATED": {
    "body": "Si vous avez payé sur ce site, la confirmation vous sera envoyé à l’adresse e-mail que vous avez donnée pendant l’opération.",
    "title": "Cet avis a déjà été payé !"
  },
  "PAYMENT_EXPIRED": {
    "body": "Contactez l’organisme pour obtenir des informations supplémentaires.",
    "title": "L’avis a expiré et ne peut plus être payé"
  },
  "PAYMENT_ONGOING": {
    "body": "Si le problème persiste, veuillez nous le signaler !",
    "title": "Il y a déjà un paiement en cours, réessayez ultérieurement"
  },
  "PAYMENT_UNAVAILABLE": {
    "title": "Cet avis rencontre un problème technique"
  },
  "PAYMENT_UNKNOWN": {
    "body": "L'avis pourrait déjà avoir été payé. Pour obtenir de l’assistance, contactez l’organisme créancier.",
    "title": "L'avis est introuvable"
  },
  "pspUnavailable": {
    "body": "Cette erreur peut se produire lorsque le montant à payer est particulièrement élevé ou si vous essayez de payer un timbre fiscal numérique.",
    "cta": {
      "primary": "Choisissez une autre méthode"
    },
    "title": "La méthode sélectionnée n'est pas disponible"
  },
  "paymentEmailPage": {
    "description": "Vous recevrez le résultat du paiement à cette adresse",
    "formButtons": {
      "back": "Retour",
      "submit": "Continuer"
    },
    "formErrors": {
      "invalid": "Saisir une adresse e-mail valide",
      "notEqual": "Les adresses e-mail ne correspondent pas",
      "required": "Champ obligatoire"
    },
    "formFields": {
      "confirmEmail": "Répéter ici",
      "email": "Adresse e-mail"
    },
    "title": "Saisir votre e-mail"
  },
  "findOutMoreModal": {
    "title": "Que faire si le paiement échoue?",
    "section1Title": "1. Payez l’avis",
    "section1ContentRow1": "N’oubliez pas de payer l’avis avant les échéances fixées par l’organisme.",
    "section1ContentRow2": "Si vous n’y parvenez pas via ce site, ",
    "section1ContentRow2Link": "découvrez les autres canaux habilités à pagoPA.",
    "section2Title": "2. Attendez le remboursement",
    "section2ContentRow1": "En général, le montant est recrédité en quelques minutes.",
    "section2ContentRow2": "Dans d’autres cas, le transfert d’argent sur votre compte ou carte peut prendre plus de temps.",
    "section3Title": "3. Contacter l’assistance",
    "section3ContentRow1": "Si vous n’avez pas encore reçu le remboursement après 5 jours ouvrables, ",
    "section3ContentRow2Link": "contactez l’assistance."
  },
  "paymentResponsePage": {
    "0": {
      "body": "Nous avons envoyé la confirmation du paiement à {{useremail}}",
      "title": "Vous avez payé {{amount}}"
    },
    "1": {
      "body": "Aucun débit n’a été effectué.",
      "title": "Une erreur inattendue s’est produite."
    },
    "2": {
      "body": "Aucun débit n’a été effectué. Vérifiez que vous avez bien suivi les consignes de votre banque.",
      "title": "Autorisation refusée"
    },
    "3": {
      "body": "Si vous avez payé avec une carte de débit ou de crédit, vérifiez que vous avez bien saisi les informations inscrites à l’avant de la carte.",
      "title": "Les informations sur le moyen de paiement sont incorrectes"
    },
    "4": {
      "body": "Aucun débit n’a été effectué. Pour votre sécurité, vous disposez d’un temps limité pour terminer l’opération.",
      "title": "La session a expiré"
    },
    "5": {
      "title": "Le circuit de la carte n’est pas pris en charge"
    },
    "6": {
      "title": "Il manque certaines informations pour effectuer le paiement"
    },
    "7": {
      "body": "Pour toute information complémentaire, contactez votre banque.",
      "title": "Le moyen de paiement a expiré ou n'est plus valable"
    },
    "8": {
      "body": "Aucun débit n’a été effectué.",
      "title": "L’opération a été annulée"
    },
    "10": {
      "body": "Aucun débit n’a été effectué. Vous avez peut-être dépassé le plafond fixé par votre banque.",
      "title": "Autorisation refusée"
    },
    "12": {
      "title": "Le moyen de paiement n’est pas pris en charge"
    },
    "17": {
      "body": "Vous recevrez le résultat du paiement à l’adresse {{useremail}}.",
      "title": "Attendez de recevoir la validation du paiement"
    },
    "18": {
      "body": "Le montant autorisé a été remboursé sur votre moyen de paiement. Le transfert d’argent peut prendre un certain temps.",
      "title": "Le paiement n’a pas abouti"
    },
    "25": {
      "body": "Aucun débit n’a été effectué.\n Si le problème persiste, essayez d’utiliser un autre moyen ou prestataire de paiement.",
      "title": "Le paiement n’a pas abouti"
    },
    "116": {
      "body": "Aucun débit n’a été effectué. Avant de réessayer, ajoutez des fonds à votre carte ou utilisez un autre moyen de paiement.",
      "title": "Le solde de votre carte est insuffisant"
    },
    "117": {
      "body": "Aucun débit n’a été effectué. Le code (CVV ou CVC) comporte 3 chiffres et se trouve au verso de la carte. Si vous utilisez American Express, le code (CID) comporte 4 chiffres et se trouve au recto.",
      "title": "Le code de sécurité saisi est incorrect"
    },
    "121": {
      "body": "Aucun débit n’a été effectué. Avant de réessayer, modifiez votre limite de dépenses ou utilisez un autre moyen de paiement.",
      "title": "Vous avez dépassé la limite de dépenses de votre carte"
    },
    "3dsNotInitiated": {
      "body": "Aucun débit n’a été effectué.\nSi le problème persiste, contactez l’opérateur de votre moyen de paiement, votre banque par exemple.",
      "title": "Nous avons rencontré un problème avec l’opérateur de votre moyen de paiement"
    },
    "buttons": {
      "continue": "Continuer",
      "findOutMode": "En savoir plus"
    },
    "survey": {
      "body": "Faites-nous part de votre expérience et aidez-nous à l’améliorer.",
      "link": {
        "href": "https://pagopa.qualtrics.com/jfe/form/SV_0jllXJcXhmSpb38",
        "text": "Aller au sondage"
      },
      "title": "Racontez-nous votre expérience"
    }
  },
  "paymentCheckPage": {
    "buttons": {
      "cancel": "Annuler",
      "submit": "Payer",
      "wait": "Attendre…"
    },
    "creditCard": "Payer avec",
    "disclaimer": {
      "cheaper": "Conseillé comme le moins cher",
      "yourCard": "Conseillé aux clients déjà inscrits",
      "psp": "En continuant, vous acceptez les  <terms>Conditions générales d'utilisation</terms> et vous confirmez avoir lu la <privacy>Politique de confidentialité</privacy> de <psp>{{pspName}}</psp>"
    },
    "drawer": {
      "body": "Cette liste vous indique tous les opérateur compatibles avec votre moyen de paiement, même si vous ne faites pas partie de leurs clients.",
      "header": {
        "amount": "Frais",
        "name": "Opérateur"
      },
      "title": "Avec quel opérateur voulez-vous payer ?",
      "selectPspAccessibilityLabel": "Sélectionner {{pspName}} comme prestataire de paiement",
      "pspNameAccessibilityLabel": "Trier par ordre alphabétique selon le nom de l’opérateur",
      "taxFeeAccessibilityLabel": "Trier à partir du montant de commission le plus bas"
    },
    "email": "Envoyer le résultat à:",
    "modal": {
      "body": "Les opérations de transfert d’argent (en comptant ou en monnaie électronique) ont un coût qui permet de garantir un paiement sûr et vérifié.\nChaque opérateur (ou PSP, Prestataire de service de paiement) chiffre ses frais en fonction de ses stratégies commerciales et de ses conditions contractuelles.\nAvec pagoPA, ces frais sont transparents et le client peut choisir librement l’option qui lui convient. Pour en savoir plus, consulter la page  ",
      "cancelBody": "Si vous quittez maintenant, les informations saisies seront perdues et vous devrez recommencer l'opération.",
      "cancelButton": "Non, J'ai changé d'avis",
      "cancelTitle": "Votre paiement est en cours, voulez-vous vraiment quitter ?",
      "link": "Transparence des frais facturés",
      "submitButton": "Sortir",
      "title": "Pourquoi y-a-t-il de frais?"
    },
    "psp": "Appliquée depuis",
    "total": "Total",
    "transaction": "Frais"
  },
  "paymentChoicePage": {
    "saved": "Enregistrés",
    "bank": "Compte bancaire",
    "button": "Retour",
    "costs": "Transparence des frais facturés",
    "creditCard": "Carte de débit ou de crédit",
    "description": "Pour en savoir plus sur les méthodes et les frais appliqués par les opérateurs adhérents, voir la page  ",
    "incoming": "Bientôt disponible",
    "others": "Autres moyens de paiement",
    "showMore": "Méthodes non disponibles",
    "title": "Comment voulez-vous payer ?",
    "feeRange": "Commission: de {{min}}  à {{max}}",
    "feeSingle": "Commission: {{value}}",
    "filterLabel": "Rechercher un moyen",
    "noPaymentMethodsAvailable": "Aucun résultat trouvé. Essayez avec un autre mot-clé.",
    "filterButton": "Filtrer",
    "drawer": {
      "title": "Filtrer les méthodes",
      "byType": "Par type",
      "byFunc": "Par fonctionnalités",
      "card": "Carte",
      "balance": "Compte bancaire",
      "appApm": "Applications et autres méthodes",
      "payByPlan": "Paiement en plusieurs fois",
      "showResults": "Afficher les résultats",
      "remove": "Effacer tous les filtres"
    }
  },
  "paymentMethods": {
    "bpay": "BANCOMAT Pay",
    "cc": "Compte bancaire",
    "cp": "Carte de débit ou de crédit",
    "ppay": "Payer avec Postepay"
  },
  "paymentNoticeChoice": {
    "form": {
      "description": "Code avis et code fiscal organisme",
      "title": "Saisir vos données"
    },
    "qr": {
      "description": "Utiliser votre webcam ou votre appareil photo",
      "title": "Scanner le QR code"
    }
  },
  "paymentNoticePage": {
    "description": "Saisir les données qui figurent sur l’avis de paiement.",
    "exampleModalAltText": "Avis de paiement pagoPA, avec en évidence la partie contenant le code de l’avis et le numéro fiscal de l’organisme créancier",
    "exampleModalTitle": "Exemple d’avis pagoPA",
    "formButtons": {
      "cancel": "Retour",
      "submit": "Continuer"
    },
    "formErrors": {
      "minCf": "Saisir 11 chiffres",
      "minCode": "Saisir 18 chiffres",
      "required": "Champ obligatoire"
    },
    "formFields": {
      "billCode": "Code avis",
      "cf": "Code fiscal organisme créancier"
    },
    "helpLink": "Voir un exemple",
    "title": "Que devez-vous payer?"
  },
  "paymentPspListPage": {
    "title": "Choisissez qui gérera le paiement",
    "description": "Chaque opérateur propose une commission. Dans cette liste, vous trouverez tous les opérateurs compatibles, <strong>même si vous n'êtes pas leur client</strong>.",
    "operator": "Opérateur",
    "alreadyClient": "Vous êtes déjà client",
    "formButtons": {
      "back": "Retour",
      "submit": "Continuer"
    },
    "sort": "Trier",
    "drawer": {
      "sorting": {
        "default": "Par défaut",
        "name": "Par nom",
        "amount": "Par montant"
      },
      "showResults": "Appliquer"
    },
    "myBankAlertTitle": "Vous ne trouvez pas votre banque ?",
    "myBankAlertBody": "Pas d'inquiétude : vous pourrez la sélectionner lors des prochaines étapes."
  },
  "paymentQrPage": {
    "camBlocked": "Nous avons besoin de votre autorisation pour utiliser l’appareil photo. Pour modifier votre choix, visitez les paramètre Confidentialité de votre navigateur",
    "description": "Vérifier votre éclairage. Si le code n’est pas mis au point, éloignez-vous légèrement de l’écran.",
    "navigate": "L’opération a échoué ? Saisir les données manuellement",
    "reloadPage": "Recharger la page",
    "title": "Scanner le code QR",
    "usageHintPc": "Cette page nécessite l’utilisation du lecteur de codes QR. Pour scanner le code QR, autorisez l’accès à la caméra dans votre navigateur lorsqu’il est demandé. Vous devrez peut-être utiliser une webcam externe ou intégrée. Le code QR doit être bien cadré et bien éclairé pour faciliter sa lecture.",
    "usageHintMobile": "Cette page nécessite l’utilisation du lecteur de codes QR. Pour scanner le code QR, autorisez l’accès à la caméra dans votre navigateur lorsqu’il est demandé. Utilisez la caméra arrière de votre smartphone et orientez-la vers le code QR. Le code QR doit être bien cadré et bien éclairé pour faciliter sa lecture."
  },
  "paymentSummaryPage": {
    "amount": "Montant mis à jour",
    "billCode": "Code avis",
    "buttons": {
      "cancel": "Retour",
      "ok": "OK",
      "submit": "Aller au paiement"
    },
    "causal": "Objet du paiement",
    "cf": "Code fiscal organisme créancier",
    "creditor": "Organisme créancier",
    "description": "Lorsque le montant change, cela signifie qu'il a été mis à jour automatiquement. S'il est plus élevé, il peut inclure des intérêts, des pénalités ou des frais de notification.\n\nSi l'avis pagoPA concerne une communication ayant une valeur juridique, l'augmentation du montant à payer peut dépendre de plusieurs facteurs, par exemple :\n• si vous avez reçu la communication par courrier recommandé (les frais d'impression et d'envoi pouvant être à la charge du destinataire) ;\n• le nombre de tentatives de livraison.\n\nPour plus de détails, contactez l'organisme créancier.",
    "dialog": {
      "description": "Lorsque le montant change, cela signifie qu'il a été mis à jour automatiquement. S'il est plus élevé, il peut inclure des intérêts, des pénalités ou des frais de notification.\n\nSi l'avis pagoPA concerne une communication ayant une valeur juridique, l'augmentation du montant à payer peut dépendre de plusieurs facteurs, par exemple :\n• si vous avez reçu la communication par courrier recommandé (les frais d'impression et d'envoi pouvant être à la charge du destinataire) ;\n• le nombre de tentatives de livraison.\n\nPour plus de détails, contactez l'organisme créancier.",
      "title": "Le montant est-il différent de celui indiqué sur l'avis pagoPA ?"
    },
    "iuv": "Code IUV",
    "title": "Données du paiement"
  },
  "POLLING_SLOW": {
    "body": "Nous vous prions d’attendre quelques minutes sans recharger la page.",
    "title": "L’opération de l’organisme est plus longue que prévu..."
  },
  "privacyInfo": {
    "googleDesc": "Formulaire protégé par reCAPTCHA et Google.",
    "privacyDesc": "En continuant, vous acceptez les <terms>Conditions d’utilisation</terms> du service et vous confirmez que vous avez lu la <privacy>Charte de confidentialité</privacy>",
    "privacyDonation": "Conditions supplémentaires du service des dons en faveur de l’urgence en Ukraine"
  },
  "STATUS_ERROR": {
    "body": "Si le problème persiste, veuillez nous le signaler !",
    "title": "Une erreur inattendue s’est produite"
  },
  "TIMEOUT": {
    "body": "Si le problème persiste, veuillez nous le signaler !",
    "title": "Le réponse de l’organisme créancier a rencontré un problème"
  },
  "errorMessageNPG": {
    "HF0001": "Saisir 3 ou 4 chiffres",
    "HF0002": "Service temporairement indisponible",
    "HF0003": "La session a expiré, retournez en arrière et réessayez",
    "HF0004": "Saisir un numéro valide",
    "HF0005": "Le circuit de cette carte n'est pas pris en charge",
    "HF0006": "Saisir mm/aa",
    "HF0007": "Saisir les informations inscrites sur la carte",
    "HF0009": "Vérification 3DS échouée"
  },
  "userSession": {
    "logoutModal": {
      "title": "Voulez-vous vraiment vous deconnecter?",
      "body": "Vous pourrez toujours effectuer le paiement sans vous connecter.",
      "submitButton": "Se déconnecter",
      "cancelButton": "Non, rester connecté"
    }
  },
  "ScheduledMaintenanceBanner": {
    "titleKey": "Maintenance programmée",
    "bodyKey": "Le paiement ne sera pas possible de 00:01 à 03:00 le 18 juillet 2025.",
    "linkTextKey": "Plus d'informations"
  },
  "maintenancePage": {
    "title": "Nous travaillons pour vous",
    "subtitle": "pagoPa n'est pas disponible pour le moment en raison d'une maintenance programmée.",
    "closeButton": "Fermer",
    "detailsButton": "En savoir plus"
  },
  "__variant-name": "Francese",
  "__variant-description": ""
}